import Actions from "./userPreferenceConstants";
import { customGet, customPost } from "../../api/customApi";
import entityType from "../../api/entityType";

export const getUserPreferences = (keys) => async (dispatch) => {
  dispatch({ type: Actions.GET_USER_PREFERENCES });
  try {
    const payload = await customGet(entityType.USER_PREFERENCE, "Get", {
      params: { preferenceKeys: keys.join(",") },
    });
    dispatch({ type: Actions.GET_USER_PREFERENCES_SUCCEEDED, payload });
  } catch (error) {
    dispatch({ type: Actions.GET_USER_PREFERENCES_FAILED, error });
  }
};

export const updateUserPreferences = (values) => async (dispatch) => {
  dispatch({ type: Actions.UPDATE_USER_PREFERENCES });
  try {
    const payload = await customPost(entityType.USER_PREFERENCE, "Update", values);
    dispatch({ type: Actions.UPDATE_USER_PREFERENCES_SUCCEEDED, payload });
  } catch (error) {
    dispatch({ type: Actions.UPDATE_USER_PREFERENCES_FAILED, error });
  }
};

export const clearUserPreferencesOperationResult = () => (dispatch) => {
  dispatch({ type: Actions.CLEAR_USER_PREFERENCES_OPERATION_RESULT });
};
